<template>
    <div>
        <list-vue
            v-bind:busqueda="busqueda"
            v-bind:busquedaTraduccion="busquedaTraduccion"
            v-bind:busquedaMedidas="busquedaMedidas"
            v-bind:opciones="opciones"
            v-bind:moduloTitulo="moduloTitulo"
            v-bind:pantallaTitulo="pantallaTitulo"
            v-bind:rutaConsulta="rutaConsulta"
            v-bind:buttonsPage="buttonsPage"
            v-bind:busquedaCampos="busquedaCampos"
            v-bind:permisos="permisos"
        ></list-vue>
    </div>
</template>
    <script type="text/javascript">
import { mapState } from "vuex";
import { mapMutations } from "vuex";
export default {
    data() {
        return {
            permisos: {},
            //Definimos los nombres generales
            moduloTitulo: "",
            reporte: false,
            pantallaTitulo: this.$root.trans("Resultado"),
            rutaConsulta: this.$route.fullPath,
            buttonsPage: [
                {
                    type: "button",
                    externalCheck: true,
                    submitCheckbox: true,
                    singleCheckbox: true,
                    class: "btn btn-xs btn-warning pull-right",
                    route: "",
                    text: "Regresar",
                    name: "sel",
                    description: '<i class="fa fa-plus">',
                },
                {
                    type: "button",
                    submitCheckbox: true,
                    class: "btn btn-xs btn-info pull-right",
                    route: "",
                    text: "Derivar",
                    name: "sel",
                    description: '<i class="fa fa-plus">',
                },
                {
                    type: "button",
                    externalCheck: true,
                    submitCheckbox: true,
                    singleCheckbox: true,
                    class: "btn btn-xs btn-success pull-right",
                    route: "",
                    text: "Adjuntar",
                    name: "sel",
                    description: '<i class="fa fa-plus">',
                },
            ],
            //Definimos los campos de busqueda, sus nombres e incluso tamaño
            busqueda: {
                sel: "",
                f__fecha_asignado: "",
                f___codigo_ficha: "",
                f___descripcion: "",
                f___etapa_actual_id: "",
                f___responsable_actual_id: "",
                f___cali_tipos_nc_id: "",
            },
            busquedaTraduccion: {
                sel: this.$root.trans("Sel."),
                f__fecha_asignado: this.$root.trans("U. Movimiento"),
                f___codigo_ficha: this.$root.trans("Codigo"),
                f___descripcion: this.$root.trans("Descripción"),
                f___etapa_actual_id: this.$root.trans("Etapa Actual"),
                f___responsable_actual_id:
                    this.$root.trans("Responsable Actual"),
                f___cali_tipos_nc_id: this.$root.trans("Tipo Ficha"),
            },
            busquedaCampos: {
                f___responsable_actual_id: {
                    type: "select",
                    options: [],
                },
                f___etapa_actual_id: {
                    type: "select",
                    options: [],
                },
                f___cali_tipos_nc_id: {
                    type: "select",
                    options: [],
                },
                sel: {
                    type: "checkbox",
                },
            },
            busquedaMedidas: {
                sel: "50px",
                f__fecha_asignado: "150px",
                f___codigo_ficha: "93px",
                f___descripcion: "250px",
                f___etapa_actual_id: "100px",
                f___responsable_actual_id: "70px",
                f___cali_tipos_nc_id: "100px",
            },
            //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
            opciones: [],
        };
    },
    computed: {
        ...mapState(["request"]),
    },
    methods: {
        ...mapMutations({ requestSet: "request" }),
    },
    mounted() {
        this.requestSet(this.$route.query);
    },
    created() {
        this.requestSet(this.$route.query);

        this.busqueda["f___proceso_id"] = "";
        this.busquedaTraduccion["f___proceso_id"] = this.$root.trans("Proceso");
        this.busquedaMedidas["f___proceso_id"] = "90px";

        this.busqueda["f___clasificacion_id"] = "";
        this.busquedaTraduccion["f___clasificacion_id"] =
            this.$root.trans("Clasific.");
        this.busquedaMedidas["f___clasificacion_id"] = "90px";

        this.buttonsPage[0].route = this.$root.UrlBase(
            "fichas/" + this.$route.params.lugar + "/acciones/regresar-etapa"
        );
        this.buttonsPage[1].route = this.$root.UrlBase(
            "fichas/" + this.$route.params.lugar + "/acciones/derivacion"
        );
        this.buttonsPage[2].route = this.$root.UrlBase(
            "fichas/" + this.$route.params.lugar + "/acciones/adjuntar-archivo"
        );

        if (this.$route.params.lugar === "AU") {
            this.moduloTitulo = this.$root.trans("Auditoria - Pendientes");
            this.buttonsPage[0].permisos = {
                opcion: "SAA",
                tarea: "AL",
            };
            this.buttonsPage[1].permisos = {
                opcion: "DFA",
                tarea: "MO",
            };
        } else if (this.$route.params.lugar === "NO") {
            this.moduloTitulo = this.$root.trans(
                "Informacion Documentada - Pendientes"
            );
            this.buttonsPage[0].permisos = {
                opcion: "RPD",
                tarea: "RE",
            };
            this.buttonsPage[1].permisos = {
                opcion: "RPD",
                tarea: "DE",
            };
        } else if (
            this.$route.params.lugar === "NC" ||
            this.$route.params.lugar === "RE"
        ) {
            this.moduloTitulo = this.$root.trans("Registro - Pendientes");
            this.buttonsPage[0].permisos = {
                opcion: "RPD",
                tarea: "RE",
            };
            this.buttonsPage[1].permisos = {
                opcion: "RPD",
                tarea: "DE",
            };
            this.busqueda.f___cliente_id = "";
            this.busqueda.f___proveedor_id = "";
            this.busquedaTraduccion.f___cliente_id =
                this.$root.trans("Cliente");
            this.busquedaTraduccion.f___proveedor_id =
                this.$root.trans("Proveedor");
            this.busquedaMedidas.f___cliente_id = "100px";
            this.busquedaMedidas.f___proveedor_id = "100px";
        }

        const data = {
            selects: {
                User2: {},
                generic: {
                    code: "id",
                    label: "descripcion",
                    model: "FichasEtapaNC",
                    order: "descripcion",
                    nc: this.$route.params.lugar,
                    concatena_descripcion: ["nodo_numer", "descrip_clasifica"],
                    where: {
                        "cali_etapas_tipo_nc.estado": "A",
                    },
                },
                generic2: {
                    code: "id",
                    label: "descripcion",
                    model: "TipoNC",
                    order: "descripcion",
                    nc: this.$route.params.lugar,
                },
            },
        };

        this.$root
            .Consulta(
                this.$root.UrlBase("selects/init-new"),
                data,
                "post",
                false,
                false,
                false,
                "",
                false
            )
            .then((response) => {
                this.busquedaCampos.f___responsable_actual_id.options =
                    response.User2;
                this.busquedaCampos.f___etapa_actual_id.options =
                    response.generic;
                this.busquedaCampos.f___cali_tipos_nc_id.options =
                    response.generic2;
            });
        this.$root
            .Consulta(
                this.$root.UrlBase("permisos"),
                data,
                "post",
                false,
                false,
                false,
                "",
                false
            )
            .then((response) => {
                this.permisos = response;
            });
    },
};
</script>
